module.exports = __webpack_public_path__ + "img/social8.75446eca.svg";